module.exports = __webpack_public_path__ + "img/ardi_logo_white.f8add51b.svg";